import { useState } from 'react';
import productGroupModel from './ProductGroup.model';

/**
 * Represents a product master model.
 * @returns {Object} An object containing the product master state and setter function.
 */
const productMasterModel = () => {
  const initialState = {
    id: '',
    itemCode: '',
    managedRange: '',
    itemDescription: '',
    description2: '',
    description3: '',
    unit: 'Each',
    abcClass: '',
    flcPageNo: '',
    internetFlag: false,
    internetTree: '',
    apnManuf: '',
    qtyBreak0: '',
    price0exGst: '',
    qtyBreak1: '',
    price1exGst: '',
    qtyBreak2: '',
    price2exGst: '',
    qtyBreak3: '',
    price3exGst: '',
    qtyBreak4: '',
    price4exGst: '',
    binLoc: '',
    minimumStock: '',
    maximumStock: '',
    itemCondition: '',
    avgCost: 0,
    taxCode: 'E',
    createdBy: '',
    productGroup: productGroupModel().initialState,
    gstFlag: false,
    promoPrice: '',
    specialFlag: false,
    supplier: '',
    onHand: '',
    packQty: '',
    whse: '',
    avgMonthDemand: '',
    priority: '',
    lastBuyPrice: '',
    convFact: '',
    webRibbon: '',
    btsPrice: null,
    normalPrice: null,
    btsConversionFactor: null,
    isBtsProduct: true,
  };

  const [productMaster, setProductMaster] = useState(initialState);

  return { productMaster, setProductMaster, initialState };
};

export default productMasterModel;
